<template>
  <div class="hello">
    <sui-button floated="left" content="Back" icon="backward" @click="$router.go(-1)" />
    
    <div>
        <h1>New client</h1>
        
        <sui-grid>
            <sui-grid-row :columns="2">
                <sui-grid-column>
                    
                    <h3 is="sui-header" attached="top">Company</h3>
                    
                    <sui-segment attached>
                    
                        <sui-form>
                            <sui-form-field>
                              <label>Name</label>
                              <input placeholder="Company name" v-model="form.name">
                            </sui-form-field>
                            <sui-form-field>
                              <label>IC</label>
                              <input placeholder="CZ123456789" v-model="form.ic">
                            </sui-form-field>
                            <sui-form-field>
                              <label>DIC</label>
                              <input placeholder="CZ123456789" v-model="form.dic">
                            </sui-form-field>
                            <sui-form-field>
                              <label>Street</label>
                              <input v-model="form.street">
                            </sui-form-field>
                            <sui-form-field>
                              <label>City</label>
                              <input v-model="form.city">
                            </sui-form-field>
                            <sui-form-field>
                              <label>Country</label>
                              <input v-model="form.country">
                            </sui-form-field>
                            <sui-form-field>
                              <label>Zip</label>
                              <input v-model="form.zip">
                            </sui-form-field>
                            <sui-form-field>
                              <label>Contact person</label>
                              <input v-model="form.contactPerson">
                            </sui-form-field>
                            <sui-form-field>
                              <label>Phone</label>
                              <input v-model="form.phone">
                            </sui-form-field>
                            <sui-form-field>
                              <label>Email</label>
                              <input v-model="form.email">
                            </sui-form-field>
                            <sui-button type="submit" v-on:click="createClient($event)">Create company</sui-button>
                          </sui-form>
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Info</h3>
                    <sui-segment attached>
                        ...
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
        
        
    </div>    
    
  </div>
</template>

<script>
import DziService from '@/DziService'


export default {
  name: 'ClientCreate',
  data () {
        return {
            form: {
                name: null,
                ic: null,
                dic: null,
                street: null,
                city: null,
                country: null,
                zip: null,
                contactPerson: null,
                phone: null,
                email: null
            }
        }
    },  
  props: {
//    msg: String
  },
  methods: {
        refresh() {
          this.device = null;
          this.getDevice();  
        },
        async getDevice () {
            const response = await DziService.getDevice(this.$route.params.id)
            this.device = response.data;
        },
        async createClient(e) {
            e.preventDefault();
            
            //TODO: validace
            const response = await DziService.createClient(this.form)
              .then(res => {
                if (res.errors && res.errors.length>0)
                {
                  console.log('errors:');
                  let messages = [];
                  res.errors.forEach(error => {
                    console.log('err:', error)
                    messages.push(error.param + ': ' + error.msg);
                  })

                  this.$store.commit('setError', messages);
                  window.scrollTo(0,0);
                }
                else
                {
                  // nastavime noveho klienta
                  this.$store.commit('setClient', {'clientId': res.data.clientId, 'clientName': res.data.name});

                  //presmerujeme na homepage
                  this.$router.push({'name': 'home'})
                }
              })
              .catch(err => {
                this.$store.commit('setError', 'Can\'t add client: ' + err);
                window.scrollTo(0,0);
              })
        },
        async deactivateDevice () {
            this.deactivating = true;
            this.unauthorizeError = null;
            const response = await DziService.deactivateDevice(this.$route.params.id)
            
            if (typeof response.data.error !== 'undefined')
            {
                this.unauthorizeError = response.data.error;
                this.deactivating = false;
            }
            else if (response.data.success == 'ok')
            {
                this.$store.commit('resetDevices');
                this.$router.push({'name': 'device_list'})
            }
                
        },
    },
    
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
